import React,{Component} from 'react';
import './Intro.css'
import {imgWrapper} from '../../sharedcomponents/ImageScope';

export default class IntroHome extends Component {
    render(){
        return(
            <div>
                <section id="intro">
                <div className="container animated wow fadeInDown">
                <div className="row">
                    <div className="col-md-7 col-sm-12">
                    <div className="block">
                        <div className="section-title">
                        <h2 style={{fontWeight:'bolder',fontFamily: 'Myriad Pro Bold'}}>Sobre Nós</h2>
                        <p style={{fontWeight:'bolder',fontFamily: 'Myriad Pro light',color:'#111','font-size': '1.125em','font-weight':'400','letter-spacing': '-.3px','line-height': '1.33333em'}}>A HS Design Lda e uma Empresa de direito 100% angolano, localizada no Bairro Cassenda, Rua 6 Bloco 77b, ap/12rc. No conjunto dos desafios que se colocam ao pais destacam-se a prossecução dos objectivos, a divulgação empresarial, assim como o trabalho artístico. </p>
                        </div>
                        <p style={{fontWeight:'bolder',fontFamily: 'Myriad Pro light',color:'#111','font-size': '1.125em','font-weight':'400','letter-spacing': '-.3px','line-height': '1.33333em'}}>Fundamentalmente para o desenvolvimento de nacional e divulgação do trabalho gráfico e têxtil, no qual ira alcançar as metas definidas. Foi o campo de intervenção na qual a HS Design Lda, escolheu para interferir na nossa sociedade.  </p>
                    </div>
                    </div>
                    <div className="col-md-5 col-sm-12">
                    <div className="block">
                        <img src={imgWrapper} alt="Img"/>
                    </div>
                    </div>
                </div>
                </div>
            </section>
          </div>
        );
    }
}

